
function matchToProjectID(match) {
  match = match || {};
  const params = match.params || {};
  return params.projectID;
}

export default matchToProjectID
